import MyBullet from './MyBullet.vue'

export default MyBullet
